import * as React from 'react'
import MUIDialogContent from '@mui/material/DialogContent'

const DialogContent = (props) => <MUIDialogContent {...props} />

export default DialogContent
